import * as FieldValidation from '../components/crud/CreateAndEditResource/FieldValidation';

export const addLeadingZeroes = (hourMinuteString) => {
  if (typeof hourMinuteString !== 'string') return hourMinuteString;
  const [hours, minutes] = hourMinuteString.split(':');
  const finalHours = addLeadingZeroIfOneDigit(hours);
  const finalMinutes = addLeadingZeroIfOneDigit(minutes);
  return `${finalHours}:${finalMinutes}`;
};

const addLeadingZeroIfOneDigit = timeString => (timeString.length === 1 ? `0${timeString}` : timeString);

export const isDayTimeLimitValid = (timeLimit) => {
  const {
    isStartATimeString, isEndATimeString, hasDaysInWeek, isStartBeforeEnd,
  } = whatInDayTimeLimitIsValid(timeLimit);
  return hasDaysInWeek && isStartATimeString && isEndATimeString && isStartBeforeEnd;
};

export const whatInDayTimeLimitIsValid = (timeLimit) => {
  const { daysOfWeek, end, start } = timeLimit;

  const isStartATimeString = isATimeString(start);
  const isEndATimeString = isATimeString(end);
  const hasDaysInWeek = FieldValidation.isArrayWithElements(daysOfWeek);
  const isStartBeforeEnd = isStartTimeBeforeEnd(start, end);
  return {
    isStartATimeString, isEndATimeString, hasDaysInWeek, isStartBeforeEnd,
  };
};

/**
 * Uses the comparison possible with time strings, e.g. '08:30' > '10:45'
 */
const isStartTimeBeforeEnd = (start, end) => {
  const correctedStart = addLeadingZeroes(start);
  const correctedEnd = addLeadingZeroes(end);
  if (
    !isATimeString(correctedStart)
    || !isATimeString(correctedEnd)
    || correctedStart > correctedEnd
  ) {
    return false;
  }
  return true;
};

export const areAllTimeLimitsValid = timeLimits => (
  timeLimits.reduce((acc, val) => (val && !isDayTimeLimitValid(val) ? false : acc), true)
);

const hourMinuteRegex = /[0-9]{1,2}:[0-9]{1,2}/;
export const isATimeString = str => typeof str === 'string' && hourMinuteRegex.test(str);

export const formatsToTryParsing = ['h:m a', 'H:m'];
